"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WGProject = void 0;
const Card_1 = require("../Card");
const CardName_1 = require("../../CardName");
const CardType_1 = require("../CardType");
const CardRenderer_1 = require("../render/CardRenderer");
const CardRequirements_1 = require("../CardRequirements");
const Tags_1 = require("../Tags");
const ValleyTrust_1 = require("../prelude/ValleyTrust");
class WGProject extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.AUTOMATED,
            name: CardName_1.CardName.WG_PROJECT,
            tags: [Tags_1.Tags.EARTH],
            cost: 9,
            requirements: CardRequirements_1.CardRequirements.builder((b) => b.chairman()),
            metadata: {
                cardNumber: 'P91',
                description: 'Requires that you are chairman. DRAW 3 PRELUDE CARDS AND PLAY 1 OF THEM. Discard the other 2.',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.br.br;
                    b.prelude().asterix();
                    b.br;
                }),
            },
        });
    }
    play(player) {
        return ValleyTrust_1.ValleyTrust.drawThreePreludesAndPlayOne(player);
    }
}
exports.WGProject = WGProject;
//# sourceMappingURL=WGProject.js.map